import { BuildingIcon } from "lucide-react";

import { ImageWithFallback } from "simplydo/react/components/ImageWithFallback";
import { styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";

const LogoFrame = styled.div<{ $size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 8px;
  border: 1px solid #e3e6ea;
  background: #f5f6f8;
  overflow: hidden;
  color: #5b6470;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: white;
  }
`;

type CompanyLogoProps = { url?: string | null; size?: number };

export const CompanyLogo = ({ url, size = 40 }: CompanyLogoProps) => {
  const fallback = <Icon icon={BuildingIcon} style={{ margin: 0 }} />;
  return (
    <LogoFrame $size={size}>
      {url ? (
        <ImageWithFallback src={url} fallbackElement={fallback} />
      ) : (
        fallback
      )}
    </LogoFrame>
  );
};
